/** @jsxImportSource @emotion/react */
import { useTheme } from '@quickbit/qb-design-system';
import { Outlet } from 'react-router-dom';

const Layout = () => {
  const { sizing, spacing } = useTheme();
  return (
    <div
      css={{
        maxWidth: sizing.large,
        marginTop: spacing.xxxs,
      }}
    >
      <Outlet />
    </div>
  );
};

export default Layout;
